import {
  SubmitRetailRateRequestRequest,
  RetailRateRequestProofType,
} from '@classpass/protobuf-definitions/lib/web/models/partners/retail_rate_requests';

import { toMinorUnits } from 'helpers/currency-symbol';

const hasLink = linkToPrice => !!linkToPrice && linkToPrice.trim() !== '';

const getDecimalSeparator = locale =>
  new Intl.NumberFormat(locale).formatToParts(1.1).find(({ type }) => type === 'decimal').value;

export const parsePriceInput = (value, locale) => String(value).replace(getDecimalSeparator(locale), '.');

export const parsePriceToMinorUnits = (currencyCode, value, locale) =>
  toMinorUnits(currencyCode, parsePriceInput(value, locale));

// proof[] = a URL entry only when a link was provided, then any file proofs.
// No `not_listed_online` sentinel — a file-only proof array is valid.
export const buildProofs = ({ linkToPrice, userId, fileProofs = [] }) => [
  ...(hasLink(linkToPrice)
    ? [
        {
          type: RetailRateRequestProofType.RETAIL_RATE_REQUEST_PROOF_TYPE_URL,
          url: linkToPrice,
          uploaded_by: String(userId),
        },
      ]
    : []),
  ...fileProofs,
];

// Builds the retail-rate-request body. msi_service_uuid is REST-only, so it's
// merged after proto toJSON (which doesn't know that field).
export const buildRetailRateRequestPayload = ({
  classId,
  msiServiceUuid,
  venue,
  formValues,
  fileProofs = [],
  userId,
  locale,
  payoutAgreementStatus,
  payoutCurrencyCode,
  payoutCurrencyUnits,
  payoutPercentage,
  payoutPercentageSource,
}) => ({
  ...SubmitRetailRateRequestRequest.toJSON({
    ...(classId == null ? {} : { class_id: classId }),
    venue_id: venue.venueId,
    retail_rate: {
      currency_code: venue.currencyCode,
      currency_units: parsePriceToMinorUnits(venue.currencyCode, formValues.servicePrice, locale),
    },
    proof: buildProofs({ linkToPrice: formValues.linkToPrice, userId, fileProofs }),
    accountability_agreement: !!formValues.accountabilityAgreement,
  }),
  ...(msiServiceUuid == null ? {} : { msi_service_uuid: msiServiceUuid }),
  ...(payoutAgreementStatus != null
    ? {
        payout_agreement_status: payoutAgreementStatus,
        payout: { currency_code: payoutCurrencyCode, currency_units: payoutCurrencyUnits },
        payout_percentage: payoutPercentage,
        payout_percentage_source: payoutPercentageSource,
      }
    : {}),
});
